import React, { Fragment } from 'react';
import { Route, Redirect } from 'react-router-dom';
import productsData from '../Data/productsData';

const DynamicPricingRoute = ({ component: Component, ...rest }) => {
  const { computedMatch } = rest;
  let fromProduct = productsData.filter(({ pathID }) => pathID === computedMatch.params.pathID);
  let productId = fromProduct.length !== 0 ? fromProduct[0].pathID : '';

  return (
    <Fragment>
      <Route
        {...rest}
        render={(props) => {
          return productId ? <Component {...props} /> : <Redirect to="/pricing" />;
        }}
      />
    </Fragment>
  );
};

export default DynamicPricingRoute;
